import { gql, useQuery, QueryHookOptions } from '@apollo/client';

import { CurrentUserQuery } from 'client/graphql/types/operations';

export type { CurrentUserQuery };

export const CURRENT_USER_FRAGMENT = gql`
  fragment CurrentUserFragment on User {
    id
    email
    name
    organization

    orders {
      id
      number
      total
      completedAt

      archive {
        id
      }
    }

    invoices {
      id
      number
      slug
      formattedTotal
      date
    }
  }
`;

export const CURRENT_USER_QUERY = gql`
  query CurrentUserQuery {
    currentUser {
      ...CurrentUserFragment
    }
  }

  ${CURRENT_USER_FRAGMENT}
`;

const useCurrentUserQuery = (
  options: QueryHookOptions<CurrentUserQuery> = {},
) => {
  return useQuery<CurrentUserQuery>(CURRENT_USER_QUERY, options);
};

export default useCurrentUserQuery;
